/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Sage_Fish_CoilInputs */

const en_bright_sage_fish_coil = /** @type {(inputs: Bright_Sage_Fish_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

const de_bright_sage_fish_coil = /** @type {(inputs: Bright_Sage_Fish_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment`)
};

/**
* | output |
* | --- |
* | "Segment" |
*
* @param {Bright_Sage_Fish_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_sage_fish_coil = /** @type {((inputs?: Bright_Sage_Fish_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Sage_Fish_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_sage_fish_coil(inputs)
	return de_bright_sage_fish_coil(inputs)
});